import { IDataGridColumnConfiguration, IDataGridValidator } from '@trackman/baseball-shared-components';
import { ColumnName } from 'enums/ColumnName';
import { IError, IReviewNote } from 'interfaces/review/IReviewDataRow';
import { ReviewDataRow } from 'models/review/ReviewDataRow/ReviewDataRow';

export const noteResolvedValidator: IDataGridValidator = {
  validate: (rows: ReviewDataRow[], columns: IDataGridColumnConfiguration[]) => {
    const noteColumn = columns.find((c) => c.columnName === ColumnName.Note);
    if (!noteColumn) {
      return rows.map((r) => []);
    }
    return rows.map((r) => validateRow(r, noteColumn));
  },
};

const validateRow = (row: ReviewDataRow, col: IDataGridColumnConfiguration) => {
  const errors: IError[] = [];
  if (row.isWarmup || row.isDeleted) {
    return [];
  }
  const note = row[col.dataKey as keyof ReviewDataRow] as IReviewNote;
  if (note && note.note && !note.isResolved) {
    errors.push({
      dataKey: col.dataKey,
      errorMessage: 'Note not resolved',
    });
  }
  return errors;
};
